import { cn } from "@/lib/helpers/cn";
import type { ComponentProps } from "react";

export function Card2({ className, ...sectionProps }: ComponentProps<"section">) {
  return (
    <section
      className={cn("tw:flex tw:bg-fill-white tw:rounded-md tw:shadow-lg", className)}
      {...sectionProps}
    />
  );
}
